import "./i18n";
import format from "./format";
import regex from "./regex";

export default {
  regex,
  format,
};
